<template>
  <!-- 库存管理 -->
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="商品报损">
        <CommodityReporting></CommodityReporting>
      </el-tab-pane>
      <el-tab-pane label="商品报溢">
        <CommodityOverflow></CommodityOverflow>
      </el-tab-pane>
      <el-tab-pane label="库存报警">
        <InventoryAlarm></InventoryAlarm>
      </el-tab-pane>
      <el-tab-pane label="报损报溢查询">
        <LossAndOverflow></LossAndOverflow>
      </el-tab-pane>
      <el-tab-pane label="当前库存查询">
        <InventoryQuery></InventoryQuery>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CommodityReporting from "./CommodityReporting.vue"; //商品报损
import CommodityOverflow from "./CommodityOverflow.vue"; //商品报溢
import InventoryAlarm from "./InventoryAlarm.vue"; //库存报警
import LossAndOverflow from "./LossAndOverflow.vue"; //报损报溢查询
import InventoryQuery from "./InventoryQuery.vue"; //当前库存查询

export default {
  name: "SlmsStock",
  components: {
    CommodityOverflow,
    InventoryAlarm,
    CommodityReporting,
    LossAndOverflow,
    InventoryQuery
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
